import { render, staticRenderFns } from "./ListFooter.vue?vue&type=template&id=6cac8692&scoped=true"
import script from "./ListFooter.vue?vue&type=script&lang=js"
export * from "./ListFooter.vue?vue&type=script&lang=js"
import style0 from "./ListFooter.vue?vue&type=style&index=0&id=6cac8692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cac8692",
  null
  
)

export default component.exports